export const appConfig = {
    ui: {
      primary: 'primeval',
      gray: 'cool',
      button: {
        base: 'uppercase justify-center items-center',
        font: 'font-bold',
        rounded: 'rounded-lg',
        default: {
          size: 'md'
        }
      },
      modal: {
        rounded: 'rounded-3xl',
        padding: 'p-0'
      },
      notifications: {
        wrapper: 'z-40',
        position: 'bottom-32 md:bottom-0',
      },
      slideover: {
        rounded: 'rounded-t-3xl rounded-b-none',
        padding: 'pb-5',
        height: 'h-auto max-h-screen'
      }
    } 
  };